import "es6-promise";
import { render } from 'react-dom';
import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import EventCourseContainer from './location/course-event-container';
import { Store, createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import * as redux from 'redux';



var app = React.createElement(EventCourseContainer);
const eventMount = document.getElementById('multiple-location-app');
render(app, eventMount);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/course-event/course-event.tsx